'use client'
import {useState, type ComponentProps} from 'react'
import {SectionAccordion} from '@fitro/customer-ui/SectionAccordion'
import {AcceptedPassList} from './AcceptedPassList'
import {useTranslation} from '../../../hooks/useTranslation'

/** The passes an offer accepts, as a details-window row like the schedule's details window. */
export function AcceptedPassesSection({passes, usableIds}: ComponentProps<typeof AcceptedPassList>) {
    const [open, setOpen] = useState(false)
    const {t} = useTranslation('client')
    const {t: landing} = useTranslation('landing')
    if (!passes.length) return null
    return <SectionAccordion variant="row" title={t('detailsSections.acceptedPasses')} description={landing('publicEntry.details.passCount', {count: passes.length})}
        isOpen={open} onToggle={() => setOpen(v => !v)}>
        {open ? <AcceptedPassList passes={passes} usableIds={usableIds}/> : null}
    </SectionAccordion>
}
